<script lang="ts">
    import InputText from '@reijor/svelte-inputs/InputText.svelte'
    import InputPhone from '@reijor/svelte-inputs/InputPhone.svelte'
    import { session } from '$lib/session'

    let useEmail = $state(true)
    let email = $state('')
    let phone = $state('')
    let otp = $state('')
    let step = $state<'identify' | 'verify'>('identify')
    let message = $state('')
    let busy = $state(false)

    // Phone as the server matches it: digits, keeping a leading +.
    function cleanPhone(value: string): string {
        const trimmed = (value ?? '').trim()
        return (trimmed.startsWith('+') ? '+' : '') + trimmed.replace(/\D/g, '')
    }

    async function sendCode() {
        message = ''
        busy = true
        try {
            const result = useEmail
                ? await session.sendOtpEmail(email.trim())
                : await session.sendOtpSms(cleanPhone(phone))
            if (result.success) {
                otp = ''
                step = 'verify'
            } else {
                message = 'That address is not a system administrator login.'
            }
        } finally {
            busy = false
        }
    }

    async function verify() {
        message = ''
        busy = true
        try {
            const identifier = useEmail ? { email: email.trim() } : { phone: cleanPhone(phone) }
            const result = await session.verifyOtp(identifier, otp.trim())
            if (!result.success) message = result.message || 'That passcode did not work.'
        } finally {
            busy = false
        }
    }

    function startOver() {
        step = 'identify'
        otp = ''
        message = ''
    }

    function toggleMethod() {
        useEmail = !useEmail
        message = ''
    }

    function onIdentifyKey(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault()
            void sendCode()
        }
    }

    function onOtpKey(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault()
            void verify()
        }
    }
</script>

<div class="min-h-screen flex items-center justify-center bg-light-background-blue">
    <div class="w-[420px] bg-white rounded-lg shadow-lg overflow-hidden">
        <div class="bg-primary px-6 py-4">
            <h1 class="text-2xl font-bold text-white">Reijor Books</h1>
            <p class="text-sm text-surface-dark">Sign in with your MarketEdge system administrator login.</p>
        </div>
        <div class="p-6 space-y-4">
            {#if step === 'identify'}
                <div class="flex items-center justify-between">
                    <span class="font-bold text-lg">{useEmail ? 'Email' : 'Phone'}</span>
                    <button class="sm-btn text-primary underline" onclick={toggleMethod}>
                        {useEmail ? 'Use a phone number instead' : 'Use an email address instead'}
                    </button>
                </div>
                {#if useEmail}
                    <InputText class="w-full h-9" bind:value={email} onkeydown={onIdentifyKey} placeholder="you@reijor.com"/>
                {:else}
                    <InputPhone class="w-full h-9" bind:value={phone}/>
                {/if}
                <button class="btn-blue w-full m-0" disabled={busy} onclick={sendCode}>
                    Send passcode by {useEmail ? 'email' : 'text'}
                </button>
            {:else}
                <div class="flex items-center justify-between">
                    <span class="font-bold text-lg">Passcode</span>
                    <button class="sm-btn text-primary underline" onclick={startOver}>Send a new one</button>
                </div>
                <InputText class="w-full h-9" bind:value={otp} onkeydown={onOtpKey} autofocus placeholder="6-digit code"/>
                <button class="btn-blue w-full m-0" disabled={busy} onclick={verify}>Sign in</button>
            {/if}
            {#if message}
                <p class="text-sm text-red-700">{message}</p>
            {/if}
        </div>
    </div>
</div>
